<template>
    <div>
        <div class="vote-result">
            <div class="page-main">
                <div class="title">分析结果</div>
                <div class="list">
                    <div class="item" v-for="item in list" :key="item.jourId">
                        <div class="cover">
                            <img :src="imgSiteUrl+item.imgUrl" alt="">
                        </div>
                        <div class="info">
                            <a-row>
                                <a-col :span="16">
                                    <div class="name">{{item.jourName}}</div>
                                </a-col>
                                <a-col :span="8">
                                    <div class="rate">
                                        推荐指数:<a-rate :value="getRate(item.score)" allow-half disabled />{{item.score}}%
                                    </div>
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col :span="8">
                                    <div class="info-item">国际刊号(ISSN)：<span>{{item.issnNo}}</span></div>
                                </a-col>
                                <a-col :span="8">
                                    <div class="info-item">国内刊号(CN)：<span>{{item.cnNo}}</span></div>
                                </a-col>
                                <a-col :span="8">
                                    <div class="info-item">出版周期：<span>{{item.cycle}}</span></div>
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col :span="8">
                                    <div class="info-item">创刊时间：<span>{{item.pubyear}}</span></div>
                                </a-col>
                                <a-col :span="8">
                                    <div class="info-item">主办单位：<span>{{item.org}}</span></div>
                                </a-col>
                                <a-col :span="8">
                                    
                                </a-col>
                            </a-row>
                            <div class="btn">
                                <a-button type="primary" ghost @click="checkResult(item.jourName)">查看分析结果</a-button>
                            </div>
                        </div>
                        <div class="clear"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import config from "../../until/configs";
import { getSessionItem } from "../../until/tools";

export default defineComponent({    

    setup() {
        let list = ref(getSessionItem('journalList'));
        let imgSiteUrl = config.imgSiteUrl;

        const router = useRouter();
        
        const getRate = (value)=>{
            var result = 0;
            if(typeof value === 'string') {
                result = Math.round(parseFloat(value)/10)/2;
            } else {
                result = Math.random(value/10)/2;
            }
            return result;
        }

        const checkResult = (name)=>{
            router.push({path:'/voteDetail',query:{name}})
        }

        onMounted(()=>{
            document.title = '投稿分析-'+config.siteTitle;
        });

        return  {
            list,
            imgSiteUrl,
            getRate,
            checkResult
        }
    }
})
</script>
<style lang="scss">
.vote-result {
    .ant-rate-star:not(:last-child) {
        margin-right: 3px;
    }
}
</style>
<style lang="scss" scoped>
@import '../../scss/vote-result.scss';
</style>